const languagePack = {
    hu: {
        common: {
            ok: "Ok",
            save: "Mentés",
            create: "Létrehozás",
            add: "Hozzáadás",
            cancel: "Mégsem",
            delete: "Törlés",
            merge: "Párosítás",
        },
        templatelist: {
            templateFetchError: "Nem sikerült a template fájlok betöltése.",
            templateTitle: "Template fájlok letöltése",
            hideTemplates: "Template fájlok elrejtése",
            showTemplates: "Template fájlok mutatása",
            noTemplates: "Nincsenek elérhető template fájlok.",
        },
        restrictedModal: {
            title: "Hozzáférés megtagadva",
            body: "Önnek nincs jogosultsága az alkalmazás eléréséhez. Kérjük, lépjen kapcsolatba a rendszergazdával.",
            footer: "OK"
        },
        toast: {
            successfulProductCreation: "Sikeres termék létrehozás",
            errorProductCreation: "Sikertelen termék létrehozás",
            successfulProductEdit: "Sikeres termék módosítás",
            errorProductEdit: "Sikertelen termék módosítás",
            successfulProductDeletion: "Sikeres termék törlés",
            errorProductDeletion: "Sikertelen termék törlés",
            skuExists: "Ez a SKU már egy másik termékhez van hozzárendelve",

            successfulConflictResolve: "Sikeres adatpárosítás",
            errorConflictResolve: "Sikertelen adatpárosítás",
            successfulConflictEdit: "Sikeres adatpárosítás szerkesztés",
            errorConflictEdit: "Sikertelen adatpárosítás szerkesztés",
        },
        errorPage: {
            pageNotFound: "Az oldal nem található",
            pageNotFound2: "Upsz! Az oldal amit keresel nem létezik.",
            somethingWentWrong: "Valami hiba történt",
            goBackHome: "Vissza a kezdőlapra",
        },
        login: {
            login_button: "Bejelentkezés",
        },
        nav: {
            logout: "Kijelentkezés",
        },
        uploadManager: {
            title: "Feltöltés",
            formTitle: "CSV/XLS/XLSX (Excel) feltöltés",
            invalidType: "Érvénytelen fájlformátum. Kérjük, töltsön fel egy CSV, XLS, vagy XLSX fájlt!",
            noFile: "Kérjük, válasszon egy érvényes fájlt!",
            dropHere: "Húzza ide a fájlt...",
            dragDropHere: "Húzzon ide egy maximum 100MB-os CSV/XLS/XLSX fájlt, vagy kattintson a kiválasztáshoz",
            distributorLabel: "Disztribútor",
            distributorPlaceholder: "Válasszon vagy írjon be új diszribútort",
            distributorValidation: "Kérem válasszon diszribútort!",
            uploading: "Feltöltés ...",
            upload: "Feltöltés",
            uploadSuccess: "Sikeres fájfeltöltés!",
            missingColumns: "Hiányzó oszlopok vagy nem megfelelő oszlop nevek miatt ezt a fájlt nem lehet feldolgozni!",
            fileTooLarge: "A fájl mérete túl nagy. Maximális méret: 100MB",

            // UPLOAD LOGS
            distributor: "Disztribútór",
            filename: "Fájl",
            date: "Feltöltés dátuma",
            status: "Státusz",
            refresh: "Frissítés",
            showlogs: "Feltöltés naplózás mutatása",
            hidelogs: "Feltöltés naplózás elrejtése",
        },
        exportManager: {
            title: "Adat exportálás",
            formTitle: "Adat export szűrők",
            startDate: "-tól",
            requiredStart: "A kezdeti dátum kötelező!",
            endDate: "-ig",
            requiredEnd: "A vége dátum kötelező!",
            noFutureEndDate: "A vége dátum nem lehet a jövőben!",
            distributorsPlaceholder: "Válasszon disztribútorokat",
            distributors: "Disztribútorok",
            brandsPlaceholder: "Válasszon márkákat",
            brands: "Márkák",
            productsPlaceholder: "Válasszon termékeket",
            products: "Termékek",
            downloading: "Letöltés ...",
            exportBtn: "Táblázat letöltése",
            conflictsWarning: "Figyelem! Fenálló adatkonfliktusok száma:",
            noDataFound: "Nincs adat a kiválasztott filterekkel.",
            max31Days: "Maximum intervallum 31 nap."
        },
        productManager: {
            title: "Termék kezelő",
            listTitle: "Termék lista",
            prdName: "Termék neve",
            sku: "SKU",
            actions: "Műveletek",
            confirmModalTitle: "Biztosan törölni szeretnéd ezt a terméket?",

            formTitle: "Új termék hozzáadása",
            formEditTitle: "Termék szerkesztése",

            formField1: 'Termék neve',
            placeholder1: 'Írja be a termék nevét',
            formFieldValidation1: 'A termék neve kötelező!',

            formField2: 'Márka csoport',
            placeholder2: 'Írja be vagy válasszon márka csoportot',
            createNewOption: "Hozzáadás",
            formFieldValidation2: 'A márka csoport kötelező',

            formField3: 'SKU',
            placeholder3: 'Írja be a SKU-t',
            formFieldValidation3: 'A SKU kötelező',

            noProduct: "Nincsenek felvett termékek"
        },
        conflictResolver: {
            title: "Konfliktusok",
            actions: "Műveletek",
            conflictingName: "Ütköző termék neve",
            productName: "Termék neve",
            sku: "SKU",

            unresolved: "Fenálló Konfliktusok",
            resolved: "Megoldott Konfliktusok",

            formTitle: "Adat párosítás",
            formEditTitle: "Párosított adat szerkesztése",

            formField1: "Elérhető termékek",
            placeholder1: 'Írja be a termék nevét vagy SKU-t vagy válasszon a listából',
            formFieldValidation1: 'Termék választás kötelező!',
            noCoflict: "Nincsenek fennálló adat konfliktusok",
            noResolvedConflict: "Nincsenek megoldott adat konfliktusok"
        },
        shopmanager:{
            title: "Bolt kezelő"
        },
    }
}

export default languagePack
